const messages = {
  title: 'Oeps! Waarom ben je hier?',
  description:
    'Het spijt ons zeer voor het ongemak. Het lijkt erop dat u\n' +
    'een pagina probeert te openen die is verwijderd of nooit heeft bestaan.',
  backHomeButton: 'Terug naar dashboard'
}

export default {
  messages
}
